import dayjs from "dayjs";
import {
  normalizeLegacyDuration,
  parseCombinedDuration,
} from "../HistoriesData/durationUtils";
import {
  chiefComplaintsData,
  medicationsData,
  proceduresData,
  historyData,
  otherSectionsData,
  examinationsData,
  appointmentData,
  investigationData,
  initialObservationData,
  InitialObservationData,
  chiefComplaintsDataForQuickConsultation,
  investigationDataForQuickConsultation,
  diagnosisData,
  AdultVaccinationData,
  referralData,
  adviceData,
  examinationsDataForPreview,
} from "./SectionsDataMap";
import { styled, Switch, Typography } from "@mui/material";
import { DoctorconsoleGrid } from "../StyledComponents";
// Function to find the object by ID
const findById = (id, data) => {
  return data.find((item) => {
    const resourceType = Object.keys(item)[0];
    return item[resourceType].id === id;
  });
};
const findByIdDiagnostic = (id, data) => {
  return data.find((item) => {
    const resourceType = Object.keys(item)[0];
    return item[resourceType].id === id && resourceType == "Observation";
  });
};
export const organizedArrayByHiTypes = (copiedArray) => {
  const modifiedFhirArray = copiedArray.map((fhirData) => {
    const modifiedFhirData = {
      ...fhirData,
      fhir_data: fhirData["fhir_data"].map((dateObject) => {
        return Object.entries(dateObject).reduce(
          (acc, [dateKey, hiTypeVal]) => {
            if (Array.isArray(hiTypeVal)) {
              const modifiedItems = hiTypeVal.map((item) => {
                return Object.entries(item).reduce(
                  (itemAcc, [key, valueArray]) => {
                    const composition = valueArray.find((entry) =>
                      entry.hasOwnProperty("Composition")
                    );

                    const encounter = valueArray.find((entry) =>
                      entry.hasOwnProperty("Encounter")
                    );
                    // console.log("Encounterrr Details", encounter);
                    let organizationObjects = null,
                      updatedOrganizationObjects = null,
                      practitionerObjects = null,
                      updatedPractitionerObjects = null;

                    organizationObjects = valueArray.filter((entry) =>
                      entry.hasOwnProperty("Organization")
                    );
                    updatedOrganizationObjects = organizationObjects.map(
                      (org) => org.Organization
                    );
                    practitionerObjects = valueArray.filter((entry) =>
                      entry.hasOwnProperty("Practitioner")
                    );
                    updatedPractitionerObjects = practitionerObjects.map(
                      (prac) => prac.Practitioner
                    );

                    const compositionSection = composition?.Composition.section;

                    if (composition && compositionSection) {
                      const newModifiedHiTypeSection = {};
                      compositionSection.forEach((sec) => {
                        let resourceTitle = sec?.title;

                        sec.reference.map((secRef) => {
                          let id;
                          if (secRef.includes("/")) {
                            id = secRef.split("/").pop();
                          } else if (secRef.includes(":")) {
                            id = secRef.split(":").pop();
                          }
                          const object = findById(id, valueArray);
                          // console.log("Find by id res", object);
                          if (object) {
                            // Get the resourceType and the corresponding data object
                            const resourceType = Object.keys(object)[0];
                            let obj = object[resourceType];
                            if (!(obj.mssg && obj.mssg.includes("malformed"))) {
                              if (resourceType === "DiagnosticReport") {
                                const result = obj.results;
                                // console.log("Diagnostic Report Before", result);
                                const newRes = result?.map((res) => {
                                  let refId;

                                  if (res?.reference.includes("/")) {
                                    refId = res?.reference.split("/").pop();
                                  } else if (res?.reference.includes(":")) {
                                    refId = res?.reference.split(":").pop();
                                  }
                                  const refObject = findByIdDiagnostic(
                                    refId,
                                    valueArray
                                  );
                                  // console.log("Find by id res", refObject);
                                  if (refObject) {
                                    let refResourceType =
                                      Object.keys(refObject)[0];
                                    let refObj = refObject[refResourceType];
                                    // console.log("Ref Obj", refObj);
                                    return refObj;
                                  }
                                  return null;
                                });

                                obj = {
                                  ...obj,
                                  results: newRes,
                                };
                                // console.log("Diagnostic Report Obj", obj);
                              }

                              //if in medication request we are receiving medication_reference that points or maps to different resource
                              if (
                                resourceType == "MedicationRequest" &&
                                obj.medication_reference &&
                                Object.keys(obj.medication_reference).length !==
                                0
                              ) {
                                // console.log("Medication Request details", obj);

                                let resourceTypeIdMedication;
                                if (
                                  obj.medication_reference.reference.includes(
                                    "/"
                                  )
                                ) {
                                  resourceTypeIdMedication =
                                    obj.medication_reference.reference
                                      .split("/")
                                      .pop();
                                } else if (
                                  obj.medication_reference.reference.includes(
                                    ":"
                                  )
                                ) {
                                  resourceTypeIdMedication =
                                    obj.medication_reference.reference
                                      .split(":")
                                      .pop();
                                }
                                // console.log(
                                //   "Id of Medication",
                                //   resourceTypeIdMedication
                                // );
                                const medicineObject = findById(
                                  resourceTypeIdMedication,
                                  valueArray
                                );
                                if (medicineObject) {
                                  let resourceTypeMedication =
                                    Object.keys(medicineObject)[0];
                                  let medicineDetails =
                                    medicineObject[resourceTypeMedication];
                                  if (
                                    !(
                                      medicineDetails.mssg &&
                                      medicineDetails.mssg.includes("malformed")
                                    )
                                  ) {
                                    // console.log(
                                    //   "medicine details",
                                    //   medicineDetails
                                    // );
                                    obj["medication"] = medicineDetails.code[0];
                                  }
                                }
                              }

                              newModifiedHiTypeSection[
                                `${resourceTitle} - (${resourceType})`
                              ] = [
                                  ...(newModifiedHiTypeSection[
                                    `${resourceTitle} - (${resourceType})`
                                  ] || []),
                                  obj,
                                ];

                              // if (
                              //   resourceTitle === "Vital Signs" ||
                              //   resourceTitle === "Vital Sign" ||
                              //   resourceTitle === "Body Measurement" ||
                              //   resourceTitle === "Other Observations" ||
                              //   resourceTitle === "Women Health" ||
                              //   resourceTitle === "General Assessment" ||
                              //   resourceTitle === "Lifestyle"
                              // ) {
                              //   newModifiedHiTypeSection[resourceTitle] = [
                              //     ...(newModifiedHiTypeSection[resourceTitle] ||
                              //       []),
                              //     obj,
                              //   ];
                              // } else {
                              //   newModifiedHiTypeSection[resourceType] = [
                              //     ...(newModifiedHiTypeSection[resourceType] ||
                              //       []),
                              //     obj,
                              //   ];
                              // }
                            }
                          }
                        });
                      });

                      if (encounter) {
                        newModifiedHiTypeSection["Encounter"] = [
                          encounter["Encounter"],
                        ];
                      }
                      newModifiedHiTypeSection["Practitioner"] = [
                        ...updatedPractitionerObjects,
                      ];
                      newModifiedHiTypeSection["Organization"] = [
                        ...updatedOrganizationObjects,
                      ];
                      newModifiedHiTypeSection["Date"] =
                        composition?.Composition?.date;

                      itemAcc[key] = newModifiedHiTypeSection;
                      return itemAcc;
                    }
                    return itemAcc;
                  },
                  {}
                );
              });
              acc[dateKey] = modifiedItems;
              return acc;
            }
            return acc;
          },
          {}
        );
      }),
    };
    return modifiedFhirData;
  });
  modifiedFhirArray.forEach((item) => {
    item.fhir_data.sort((a, b) => {
      // console.log("a",Object.keys(a))
      // console.log("b",Object.keys(b))
      const keyA = Object.keys(a)[0];
      const keyB = Object.keys(b)[0];
      // console.log("Key A",keyA);
      // console.log("Key B",keyB);
      // Compare the date strings directly
      return new Date(keyB) - new Date(keyA); // Sort in descending order based on the date
    });
  });

  return modifiedFhirArray;
};

//extract time(12 hour format) from date string without any conversion
//pass parameter like "2026-02-27T10:00:00Z"
export const extractTimeFromDateString = (dateString) => {
  const timePart = dateString.split("T")[1].slice(0, 5);
  const [hour, minute] = timePart.split(":");
  const formatted =
    `${((hour % 12) || 12)}:${minute} ${hour < 12 ? "AM" : "PM"}`;
  return formatted;
};

// convert utc to ist time(day-month-year hr:min)
export const formatDateIST = (dateString, key) => {
  // This helper is used in multiple PDF render paths; be defensive.
  if (!dateString) return "";

  const normalized =
    dateString instanceof Date ? dateString.toISOString() : dateString;

  // If it's not a string (or can't be treated as one), just coerce safely.
  if (typeof normalized !== "string") return String(normalized);

  if (!normalized.includes("T")) {
    return normalized;
  }

  const dateObj = new Date(normalized);
  if (Number.isNaN(dateObj.getTime())) return normalized;
  // console.log("Op Date", dateObj);
  // Get date in 24-June-2024 format
  const optionsDate = { day: "2-digit", month: "long", year: "numeric" };
  const formattedDate = dateObj
    .toLocaleDateString("en-GB", optionsDate)
    .replace(/\s/g, "-");
  if (key) {
    return formattedDate;
  }
  // Get time in 06:23 AM/PM format
  const optionsTime = { hour: "2-digit", minute: "2-digit", hour12: true };
  const formattedTime = dateObj.toLocaleTimeString("en-US", optionsTime);

  return `${formattedDate} ${formattedTime}`;
};

// date with date time in utc
export const formatDateTime = (dateString) => {
  // Create a new Date object for the given date
  const date = new Date(dateString);

  // Create a new Date object for the current time
  const now = new Date();

  // Combine the given date with the current time
  date.setHours(
    now.getHours(),
    now.getMinutes(),
    now.getSeconds(),
    now.getMilliseconds()
  );

  // Return the combined date and time in ISO 8601 format
  return date.toISOString();
};

export const formatDateYYYYMMDD = (dateString) => {
  const date = dayjs(dateString);
  if (!date.isValid()) {
    return "Invalid Date";
  }
  return date.format("YYYY-MM-DD");
};

export const formatDDMMYYYY = (dateString) => {
  const date = new Date(dateString);

  const formattedDate = `${date.getDate().toString().padStart(2, "0")}-${(
    date.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}-${date.getFullYear()}`;

  return formattedDate;
};
//converting IST to UTC
//input string = "2025-02-01T16:30:00.000"
// Output: "2025-02-01T11:00:00.000" in string
export const convertISTtoUTC = (istDatetime) => {
  // Create a Date object by appending 'Z' to ensure it's treated as UTC
  let istDate = new Date(istDatetime + "Z");

  // Convert IST to UTC by subtracting 5 hours 30 minutes (IST is UTC+5:30)
  let utcDate = new Date(istDate.getTime() - 5.5 * 60 * 60 * 1000);
  console.log("timeeeeeeeeeeeeeeee", utcDate.toISOString().replace("Z", ""));
  // Format the UTC date to the required string format
  return utcDate.toISOString().replace("Z", "");
};

// resouce type camelcasing
export const separateCamelCase = (inputString) => {
  // Split the camel-cased string into separate words
  let words = inputString
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .split(/(?=[A-Z])/);

  // Pluralize the last word based on the ending character(s)
  let lastWord = words[words.length - 1];
  if (
    lastWord.endsWith("y") &&
    !lastWord.endsWith("ay") &&
    !lastWord.endsWith("ey") &&
    !lastWord.endsWith("iy") &&
    !lastWord.endsWith("oy") &&
    !lastWord.endsWith("uy")
  ) {
    lastWord = lastWord.slice(0, -1) + "ies";
  } else if (!lastWord.endsWith("s")) {
    lastWord += "s";
  }

  // Replace the last word with the pluralized version
  words[words.length - 1] = lastWord;

  // Join the words back together with a space and return
  return words.join(" ");
};
const SUB_DAY_DURATION_UNITS = new Set(["minute", "minutes", "hour", "hours"]);

const DURATION_FIELD_PRESETS = {
  onset: [
    (record) =>
      normalizeLegacyDuration(
        record?.condition_onset,
        record?.condition_onset,
        record?.condition_onset_type
      ),
    (record) => record?.duration,
    (record) =>
      normalizeLegacyDuration(
        record?.duration,
        record?.duration,
        record?.chiefComplaintDurationType
      ),
    (record) =>
      normalizeLegacyDuration(
        record?.onset_duration,
        record?.onset_duration,
        record?.onset_duration_type
      ),

    (record) =>
      normalizeLegacyDuration(record?.duration, record?.duration, record?.durationType),
  ],
  abatement: [
    (record) => record?.abatement_duration,
    (record) =>
      normalizeLegacyDuration(
        record?.abatement_duration,
        record?.abatement_duration,
        record?.abatement_duration_type
      ),
    (record) => record?.condition_duration,
    (record) =>
      normalizeLegacyDuration(
        record?.condition_duration,
        record?.condition_duration,
        record?.condition_duration_type
      ),
    (record) =>
      normalizeLegacyDuration(record?.duration, record?.duration, record?.durationType),
  ],
};

export const isSubDayCombinedDuration = (combined) => {
  try {
    const trimmed = String(combined ?? "").trim();
    if (!trimmed) return false;

    const parsed = parseCombinedDuration(trimmed);
    if (parsed.value && parsed.unit) {
      return SUB_DAY_DURATION_UNITS.has(parsed.unit);
    }

    return /\b\d+\s*(minute|minutes|hour|hours)\b/i.test(trimmed);
  } catch {
    return false;
  }
};

export const pickCombinedDurationFromRecord = (
  record,
  preset = "onset",
  { subDayOnly = true } = {}
) => {
  if (record == null || typeof record !== "object") return "";

  const pickers = DURATION_FIELD_PRESETS[preset] || DURATION_FIELD_PRESETS.onset;

  for (const pick of pickers) {
    try {
      const candidate = String(pick(record) ?? "").trim();
      if (!candidate) continue;
      if (!subDayOnly || isSubDayCombinedDuration(candidate)) {
        return candidate;
      }
    } catch {
      // Skip invalid field combinations and try the next candidate.
    }
  }

  return "";
};

export const applySubDayDurationFallback = (fallbackLabel, record, preset = "onset") => {
  if (fallbackLabel !== "Today" && fallbackLabel !== "Same day") {
    return fallbackLabel;
  }

  const duration = pickCombinedDurationFromRecord(record, preset);
  return duration || fallbackLabel;
};

export const getHumanReadableDiffInPastDate = (dateString, record = null) => {
  try {
    if (dateString == null || String(dateString).trim() === "") {
      return "Invalid date";
    }

    const today = dayjs();
    const inputDate = dayjs(dateString);

    if (!inputDate.isValid()) return "Invalid date";

    const diffInDays = today.diff(inputDate, "day");
    const diffInWeeks = today.diff(inputDate, "week");
    const diffInMonths = today.diff(inputDate, "month");
    const diffInYears = today.diff(inputDate, "year");

    if (diffInYears >= 1) {
      return `${diffInYears} year${diffInYears > 1 ? "s" : ""}`;
    }
    if (diffInMonths >= 1) {
      return `${diffInMonths} month${diffInMonths > 1 ? "s" : ""}`;
    }
    if (diffInWeeks >= 1) {
      return `${diffInWeeks} week${diffInWeeks > 1 ? "s" : ""}`;
    }
    if (diffInDays >= 1) {
      return `${diffInDays} day${diffInDays > 1 ? "s" : ""}`;
    }

    return applySubDayDurationFallback("Today", record, "onset");
  } catch (error) {
    console.warn("getHumanReadableDiffInPastDate failed:", error);
    return "Invalid date";
  }
};

export const getHumanReadableDiffInPastDateWithAgo = (dateString, record = null) => {
  const diff = getHumanReadableDiffInPastDate(dateString, record);
  if (diff === "Today" || diff === "Invalid date") return diff;
  return `${diff} ago`;
};

export const getHumanReadableDurationInDate = (
  onset_datetime,
  dateString,
  record = null
) => {
  try {
    if (
      onset_datetime == null ||
      dateString == null ||
      String(onset_datetime).trim() === "" ||
      String(dateString).trim() === ""
    ) {
      return "Invalid date";
    }

    const onset_date = dayjs(onset_datetime);
    const endDate = dayjs(dateString);

    if (!onset_date.isValid() || !endDate.isValid()) return "Invalid date";

    const diffInYears = endDate.diff(onset_date, "year");
    const diffInMonths = endDate.diff(onset_date, "month");
    const diffInWeeks = endDate.diff(onset_date, "week");
    const diffInDays = endDate.diff(onset_date, "day");

    if (diffInYears >= 1) {
      return `${diffInYears} year${diffInYears > 1 ? "s" : ""}`;
    }
    if (diffInMonths >= 1) {
      return `${diffInMonths} month${diffInMonths > 1 ? "s" : ""}`;
    }
    if (diffInWeeks >= 1) {
      return `${diffInWeeks} week${diffInWeeks > 1 ? "s" : ""}`;
    }
    if (diffInDays >= 1) {
      return `${diffInDays} day${diffInDays > 1 ? "s" : ""}`;
    }

    return applySubDayDurationFallback("Same day", record, "abatement");
  } catch (error) {
    console.warn("getHumanReadableDurationInDate failed:", error);
    return "Invalid date";
  }
};

/** Maps backend `appointment_type` (e.g. get_doctor_appointments) to a short PDF label. */
export const formatAppointmentTypeForPdf = (appointmentType) => {
  if (appointmentType == null || String(appointmentType).trim() === "") {
    return "New visit";
  }
  const t = String(appointmentType).trim().toUpperCase().replace(/-/g, "_");
  if (t === "FIRST_VISIT") return "New visit";
  if (t === "FOLLOW_UP") return "Follow-up visit";
  if (t === "REPORT_VISIT") return "Report visit";
  return String(appointmentType).replace(/_/g, " ");
};

export const renderEachSection = (
  source,
  sectionName,
  selectedSectionsData,
  hasVitalValue,
  vitals,
  bloodGroup,
  hasDentalData,
  dentalData,
  historyDetails,
  followUpError,
  referralError,
  fromDoctorConsole
) => {
  switch (sectionName) {
    case "Chief Complaints":
      return fromDoctorConsole?.includes("QuickConsultation")
        ? chiefComplaintsDataForQuickConsultation(
          selectedSectionsData["Chief Complaints"]
        )
        : chiefComplaintsData(selectedSectionsData["Chief Complaints"]);
    case "Medications":
      return medicationsData(selectedSectionsData["Medications"]);
    case "Procedures":
      return proceduresData(selectedSectionsData["Procedures"]);
    case "Medical Advice":
      return adviceData(selectedSectionsData["MedicalAdvice"]);
    case "Diagnosis":
      // return otherSectionsData(selectedSectionsData["Diagnosis"]);
      return diagnosisData(selectedSectionsData["Diagnosis"]);
    case "Tests/Investigations":
      return fromDoctorConsole?.includes("QuickConsultation")
        ? investigationDataForQuickConsultation(
          selectedSectionsData["Tests/Investigations"]
        )
        : investigationData(selectedSectionsData["Tests/Investigations"]);
    case "Examinations":
      return examinationsDataForPreview(
        hasVitalValue,
        vitals,
        bloodGroup,
        hasDentalData,
        dentalData
      );
    case "Follow Up/Referral":
      return appointmentData(
        selectedSectionsData["FollowUp"],
        selectedSectionsData["Referral"],
        followUpError,
        referralError,
        selectedSectionsData["IPDAdmissionReferral"] || [],
        {} // no separate IPD error object available in this context
      );
    // case "History":
    //   // console.log(historyDetails);
    //   return historyData(historyDetails);
    // case "History":
    //   return initialObservationData(selectedSectionsData["InitialObservation"]);
    case "History":
      return source === "Doctor Console" ? (
        <>
          {historyData(historyDetails)}
          <InitialObservationData
            data={selectedSectionsData["InitialObservation"]}
          />
        </>
      ) : (
        historyData(historyDetails) // only history data when source is not "Doctor Console"
      );

    case "Adult Vaccination":
      return (
        <AdultVaccinationData data={selectedSectionsData["Adult Vaccination"]} />
      );

    default:
      return null;
  }
};

const createGradientSwitch = (startColor, endColor, thumbColor = startColor) =>
  styled(Switch)(({ theme }) => ({
    "& .MuiSwitch-switchBase": {
      "&.Mui-checked": {
        color: "#fff",
        transform: "translateX(20px)",
        "& + .MuiSwitch-track": {
          backgroundImage: `linear-gradient(90deg, ${startColor}, ${endColor})`,
          opacity: 1,
        },
        "& .MuiSwitch-thumb": {
          backgroundColor: thumbColor, // thumb now matches variant color
        },
      },
    },
    "& .MuiSwitch-thumb": {
      backgroundColor: "#f0f0f0", // unchecked thumb
    },
    "& .MuiSwitch-track": {
      borderRadius: 20,
      // backgroundColor: "#99999974",
      opacity: 1,
      transition: theme.transitions.create([
        "background-color",
        "background-image",
      ]),
    },
  }));

export const SwitchWithLabel = ({
  id,
  label,
  checked,
  disabled,
  onChange,
  variant,
}) => {
  // Pick gradient colors per variant
  let startColor = "#21cdc0",
    endColor = "#2979ff"; // default blue-green

  if (variant === "green") {
    startColor = "#43a047";
    endColor = "#2e7d32";
  } else if (variant === "purple") {
    startColor = "#6a1b9a";
    endColor = "#2979ff";
  }

  const GradientSwitch = createGradientSwitch(startColor, endColor);

  return (
    <DoctorconsoleGrid item xs={4}>
      <DoctorconsoleGrid container alignItems="center" spacing={1}>
        {/* Label */}
        <DoctorconsoleGrid
          item
          sm={12}
          md={7}
          container
          justifyContent={{ xs: "center", md: "flex-end" }}
          style={{ textAlign: "center", alignContent: "flex-end" }}
        >
          <Typography
            sx={{
              fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: 700,
              lineHeight: "20px",
              color: "#6A6A6A",
            }}
            component="h2"
            htmlFor={id}
            className="console-heading small-font"
          >
            {label}
          </Typography>
        </DoctorconsoleGrid>

        {/* Switch */}
        <DoctorconsoleGrid
          item
          sm={12}
          md={5}
          container
          justifyContent={{ xs: "center", md: "flex-start" }}
          style={{ textAlign: "left", alignContent: "flex-start" }}
        >
          <GradientSwitch
            id={id}
            disabled={disabled}
            checked={checked}
            onChange={onChange}
          />
        </DoctorconsoleGrid>
      </DoctorconsoleGrid>
    </DoctorconsoleGrid>
  );
};
